var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pricing"}},[(!_vm.products.length)?_c('div',{staticClass:"loading"},[_c('span',[_vm._v(_vm._s(_vm.$t('default.Loading…')))])]):_vm._l((_vm.products),function(product){return _c('Product',{key:product.uuid,attrs:{"product":product}})})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }